import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-arc42',
  standalone: true,
  imports: [],
  templateUrl: './arc42.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './arc42.component.scss'
})
export class Arc42Component {

}
